let $ = jQuery;

module.exports = {
  attach: function (context, settings) {
    $(context).find('.dropdown select').bind('focus', function() {
      $(this).parents('.dropdown').addClass('dropdown--focus')
    });

    $(context).find('.dropdown select').bind('blur', function() {
     $(this).parents('.dropdown').removeClass('dropdown--focus')
    });
  }
};
